export const calendarDayOfWeek_Sunday = "_RbNze";
export default {calendarDayOfWeek_Sunday};